import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { apiCall } from '../../config/api';

interface Props {
  src: string;
  alt?: string;
  className?: string;
  onClick?: () => void;
  onContextMenu?: (e: React.MouseEvent) => void;
}

const AuthImage: React.FC<Props> = ({ src, alt, className, onClick, onContextMenu }) => {
  const { token } = useAuth();
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    if (!src || !token) return;
    let revoked = false;
    let url = '';

    // Strip the /api/v1 prefix — apiCall adds it
    const endpoint = src.replace(/^\/api\/v1/, '');

    apiCall(endpoint, { method: 'GET' }, token)
      .then(r => {
        if (!r.ok) throw new Error(`${r.status}`);
        return r.blob();
      })
      .then(blob => {
        url = URL.createObjectURL(blob);
        if (!revoked) setBlobUrl(url);
      })
      .catch(() => setErrored(true));

    return () => {
      revoked = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [src, token]);

  if (errored) return (
    <div className="flex items-center gap-1 text-xs opacity-60">
      <span>Image unavailable</span>
    </div>
  );

  if (!blobUrl) return (
    <div className={`rounded-lg bg-base-300 animate-pulse ${className ?? 'max-h-48 min-w-[6rem] min-h-[4rem]'}`} />
  );

  return (
    <img
      src={blobUrl}
      alt={alt}
      className={className}
      onClick={onClick}
      onContextMenu={onContextMenu}
      draggable={false}
    />
  );
};

export default AuthImage;
